import { render, staticRenderFns } from "./sglRatings.vue?vue&type=template&id=06061fd3&scoped=true&"
import script from "./sglRatings.vue?vue&type=script&lang=js&"
export * from "./sglRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06061fd3",
  null
  
)

export default component.exports